import { render, staticRenderFns } from "./activateRetention.vue?vue&type=template&id=705a57fe&"
import script from "./activateRetention.vue?vue&type=script&lang=js&"
export * from "./activateRetention.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('705a57fe')) {
      api.createRecord('705a57fe', component.options)
    } else {
      api.reload('705a57fe', component.options)
    }
    module.hot.accept("./activateRetention.vue?vue&type=template&id=705a57fe&", function () {
      api.rerender('705a57fe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/datalist/activateRetention.vue"
export default component.exports